import { render, staticRenderFns } from "./RequestDialog.vue?vue&type=template&id=652814cb&lang=pug"
import script from "./RequestDialog.vue?vue&type=script&lang=js"
export * from "./RequestDialog.vue?vue&type=script&lang=js"
import style0 from "./RequestDialog.vue?vue&type=style&index=0&id=652814cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports